module.exports = __webpack_public_path__ + "assets/img/contact30px.f65d014a.svg";